var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"imgBox"},[_c('div',[_c('img',{staticStyle:{"width":"45px","height":"45px"},attrs:{"src":_vm.editImageObj.src,"alt":""}})]),_vm._v(" "),(_vm.showDelete)?_c('p',{staticClass:"iconDelete",on:{"click":_vm.handleClose}},[_c('Icon',{staticStyle:{"color":"#fff"},attrs:{"type":"md-close"}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790f292d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/store/store-physicalColums.vue
// module id = null
// module chunks = 